module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-battle-schedule-64.fe51d07f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-battle-schedule-64.png
// module id = 3183
// module chunks = 11